function Upload (){
  return(
    <p id="Upload" className="col-3">
      Upload
    </p>
  )
}

export default Upload;